import { useApiConfig } from '../../../composables/useApi';
import type { ApiConfig } from '../../../composables/useApi';
async function postForHtml(url: string, q: string): Promise<string> {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ q }),
    credentials: 'include',
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`HTTP ${res.status}: ${text}`);
  }
  const text = await res.text();
  // Try JSON first; if fails, treat as raw HTML
  try {
    const json: any = JSON.parse(text);
    if (typeof json?.data === 'string') return json.data;
    if (typeof json?.html === 'string') return json.html;
    if (typeof json?.tpl === 'string') return json.tpl;
    // Unknown shape: if it's an object, no usable field; fallback to empty
    return '';
  } catch {
    // Not JSON -> assume raw HTML snippet
    return text;
  }
}

export const productApi = {
  searchWithConfig: async (api: ApiConfig, q: string) => {
    return postForHtml(api.apiProductSearch, q);
  }, // server returns HTML snippet (raw or JSON-wrapped)
  search: async (q: string) => {
    const api = useApiConfig();
    return productApi.searchWithConfig(api, q);
  },
};
